var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invitation h-screen"},[(_vm.currentPage == 0)?_c('InvitationComponent'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }